import {
  HELP_NOTE_UPDATE,
  OPTIONS_UPDATE,
  RESET_OPTIONS,
  RATING_ADDL_UPDATE
} from './actions';

export const initialState = {
  helpNote: '',
  redesignOptions: {
    swap: false,
    help: false,
    looking: false,
    incorrect: false,
    other: false
  },
  redesignRatingAddlFeedback: []
};

export const assistantReducerKey = 'redesignAssistant';

export const assistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case HELP_NOTE_UPDATE:
      return {
        ...state,
        helpNote: action.payload
      };
    case OPTIONS_UPDATE:
      return {
        ...state,
        redesignOptions: action.payload
      };
    case RESET_OPTIONS:
      return {
        ...state,
        redesignOptions: initialState.redesignOptions
      };
    case RATING_ADDL_UPDATE:
      return {
        ...state,
        redesignRatingAddlFeedback: action.payload
      };
    default:
      return state;
  }
};
